import React, { useEffect, useState } from 'react';
import { phone_add_plus_one } from '../../utils/commonUtil';
import CreateAccount from './CreateAccount';
import AccountInfo from './AccountInfo';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import laundryCarelogo from '../../images/laundry-care-logo-2.png';
import pushLaundryLogo from '../../images/Push_Laundry_white_logo.png';

function OrgSignupDetails({ token, loading, data }) {
  const [accountData, setAccountData] = useState({});
  const [step, setStep] = useState(1);
  useEffect(() => {
    setAccountData({
      ...data,
      billing_contact_first_name: data?.first_name || '',
      billing_contact_last_name: data?.last_name || '',
      billing_contact_email: data?.email || '',
      billing_contact_phone_number: [
        {
          type: 'MOBILE',
          label: 'phone',
          phone_number: data?.phone_numbers?.length > 0 ? data?.phone_numbers[0]?.phone_number : '',
        },
      ],
    });
  }, [data]);
  return (
    <div className='flex h-[100dvh] overflow-hidden'>
      <div className='relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden'>
        <main className='grow bg-[#01235A]'>
          <header className='bg-white text-center'>
            <div className='inline-flex py-4 sm:mb-0 sm:py-12'>
              {loading ? (
                <div className='flex h-40 w-40 items-center justify-center rounded-lg bg-gray-300'>
                  <svg
                    className='h-10 w-10 text-gray-200'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='currentColor'
                    viewBox='0 0 20 18'
                  >
                    <path d='M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z' />
                  </svg>
                </div>
              ) : (
                <img
                  className='flex max-w-xs  items-center justify-center'
                  src={
                    accountData?.tenant_id == 1
                      ? laundryCarelogo
                      : pushLaundryLogo
                  }
                />
              )}
            </div>
            <div className='w-full bg-black px-4 py-4 text-white sm:px-6  lg:px-8'>
              <div className='mx-auto max-w-3xl'>
                <div className='mb-2 flex items-center justify-center'>
                  {loading ? (
                    <div>
                      <div className='mb-4 h-2.5 w-48 rounded-full bg-gray-200'></div>
                      <div className='h-2 w-32 rounded-full bg-gray-200'></div>
                    </div>
                  ) : (
                    <h2 className='text-2xl font-bold '>{accountData?.organization_name}</h2>
                  )}
                </div>
              </div>
            </div>
          </header>
          <div className='mx-auto  max-w-md justify-center   '>
            <div className='  p-6'>
              <section>
                {loading ? (
                  <div className='flex justify-center'>
                    <div className='mb-1 h-4 w-48 rounded-full bg-gray-200'></div>
                  </div>
                ) : (
                  <p className=' mb-1  text-center text-xl font-bold text-white'>Create Your Account</p>
                )}
                {step === 2 && (
                  <div className='mb-2 mt-4 flex justify-center'>
                    <button className='text-white' onClick={() => setStep(1)}>
                      <ChevronLeftIcon className='mr-2 inline-block h-5 w-5' /> Back
                    </button>
                  </div>
                )}
                {step === 1 && (
                  <AccountInfo
                    setStep={setStep}
                    accountData={accountData}
                    setAccountData={setAccountData}
                    loader={loading}
                  />
                )}
                {step === 2 && (
                  <CreateAccount
                    accountData={accountData}
                    setStep={setStep}
                    setAccountData={setAccountData}
                    data={data}
                    token={token}
                  />
                )}
              </section>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default OrgSignupDetails;
